import { borrowersInviteApi } from 'store/api';
import { IBorrowersInviteLink, IInviteBorrowerParams } from 'api/digifi/BorrowersInviteApi';
import { createSafeQueryFn } from './utils/queries';
import { apiSlice } from './apiSlice';

export const borrowersInviteSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBorrowersInviteLink: builder.query<
      IBorrowersInviteLink,
      void
    >({
      queryFn: createSafeQueryFn(async () => {
        return borrowersInviteApi.getInviteLink();
      }),
    }),
    inviteBorrower: builder.mutation<
      void,
      IInviteBorrowerParams
    >({
      queryFn: createSafeQueryFn(async (params) => {
        await borrowersInviteApi.invite(params);
      }),
    }),
  }),
});

export const {
  useGetBorrowersInviteLinkQuery,
  useInviteBorrowerMutation,
} = borrowersInviteSlice;
